import { memo, useEffect, useState, forwardRef } from 'react';
import './SearchComponent.scss';
import { cn } from '../../../utils/string/cn.utils';
import { useTranslation } from 'react-i18next';

const SearchComponent = forwardRef(
  (
    {
      placeholder,
      value,
      setValue,
      onFocus,
      onClick,
      onShowResponse,
      inputId,
      style,
      styles,
      size = 'large',
      name,
      className,
      readOnly = false,
      autoFocus = false,
    },
    ref
  ) => {
    const { t } = useTranslation();
    const [search, setSearch] = useState('');
    const [inputRef, setInputRef] = useState(null);

    useEffect(() => {
      if (!search) {
        setSearch(value);
      }
    }, [value]);

    useEffect(() => {
      if (autoFocus && inputRef) {
        setTimeout(() => {
          inputRef.focus();
        }, 100);
      }
    }, [autoFocus, inputRef]);
    return (
      <div className={cn('input__search', className)} style={{ ...style }}>
        <input
          ref={node => {
            setInputRef(node);
            if (ref) {
              if (typeof ref === 'function') {
                ref(node);
              } else {
                ref.current = node;
              }
            }
          }}
          autoFocus={autoFocus}
          readOnly={readOnly}
          type="text"
          id={
            'search' +
            (inputId ??
              Date.now().toString(36) + Math.random().toString(36).substr(2))
          }
          name={name}
          placeholder={placeholder ?? t('Search')}
          value={value}
          onChange={e => {
            setSearch(e.target.value);
            if (setValue) setValue(e.target.value);
            if (onShowResponse) {
              onShowResponse();
            }
          }}
          autoComplete="off"
          onFocus={onFocus}
          onClick={onClick}
          style={{
            height: size === 'small' ? '32px' : '40px',
            padding: size === 'small' && '6px 8px 6px 36px',
            ...(styles?.input ?? {}),
          }}
          className={cn(
            size === 'small' ? 'text-body-medium' : 'text-body-medium'
          )}
        />
        <span
          style={{
            height: size === 'small' ? '16px' : '24px',
            width: size === 'small' ? '16px' : '24px',
          }}
          className="icon"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            style={{ flex: '1 0 0', alignSelf: 'stretch' }}
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path d="M16.3333 17.5L11.0833 12.25C10.6667 12.5833 10.1875 12.8472 9.64583 13.0417C9.10417 13.2361 8.52778 13.3333 7.91667 13.3333C6.40278 13.3333 5.12153 12.809 4.07292 11.7604C3.02431 10.7118 2.5 9.43056 2.5 7.91667C2.5 6.40278 3.02431 5.12153 4.07292 4.07292C5.12153 3.02431 6.40278 2.5 7.91667 2.5C9.43056 2.5 10.7118 3.02431 11.7604 4.07292C12.809 5.12153 13.3333 6.40278 13.3333 7.91667C13.3333 8.52778 13.2361 9.10417 13.0417 9.64583C12.8472 10.1875 12.5833 10.6667 12.25 11.0833L17.5 16.3333L16.3333 17.5ZM7.91667 11.6667C8.95833 11.6667 9.84375 11.3021 10.5729 10.5729C11.3021 9.84375 11.6667 8.95833 11.6667 7.91667C11.6667 6.875 11.3021 5.98958 10.5729 5.26042C9.84375 4.53125 8.95833 4.16667 7.91667 4.16667C6.875 4.16667 5.98958 4.53125 5.26042 5.26042C4.53125 5.98958 4.16667 6.875 4.16667 7.91667C4.16667 8.95833 4.53125 9.84375 5.26042 10.5729C5.98958 11.3021 6.875 11.6667 7.91667 11.6667Z" />
          </svg>
        </span>
      </div>
    );
  }
);

SearchComponent.displayName = 'SearchComponent';

export default memo(SearchComponent);
